<?php

Namespace Model\Register;

class PageModel extends \Model\Base
{

    public $returned_data;

    public function getPage()
    {
        $page = array();
        $page['title'] = 'Register a new Video Interviews';
        $page['heading'] = 'Video Interviews is waiting for you, come over and Register!';
        \ISOPHP\js_core::$console->log('Register Mod', $page);
        return $page;
    }

    public function getRegisterHiringResult($pageVars)
    {
        $vars['control'] = 'Register';
        $vars['action'] = 'attempt';
        $vars['api_uri'] = '/api/employer-create';

        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars['username'] = $jQuery('#username')->val();
        $vars['pwd'] = $jQuery('#pass')->val();
        $vars['first_name'] = $jQuery('#first_name')->val();
        $vars['last_name'] = $jQuery('#last_name')->val();
        $vars['email'] = $jQuery('#email')->val();
        $vars['company_name'] = $jQuery('#company_name')->val();
        $vars['dateofbirth'] = $jQuery('#dateofbirth')->val();
        $vars['telephone'] = $jQuery('#telephone')->val();
        $vars['address'] = $jQuery('#address')->val();
        $vars['user_type'] = 2;

        $form_valid = $this->validateHiringForm();
        if ($form_valid !== true) {
            $message = 'Invalid Registration Form';
            \Core\WindowMessage::showMessage($message, 'bad');
            return false;
        }
        if ($form_valid === true) {
            $message = 'Valid Registration Form - Trying now...';
            \Core\WindowMessage::showMessage($message, 'good');
            #return true;
        }
        $afterwards = $this->applyRegisterResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        return $result;
    }

    public function getRegisterEmployeeResult($pageVars)
    {
        $vars['control'] = 'Register';
        $vars['action'] = 'attempt';

        $vars['api_uri'] = '/api/candidates-create';


        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars['username'] = $jQuery('#username')->val();
        $vars['pwd'] = $jQuery('#pass')->val();
        $vars['full_name'] = $jQuery('#full_name')->val();
        $vars['email'] = $jQuery('#email')->val();
        //$vars['company_name'] = $jQuery('#company_name')->val();
        $vars['user_type'] = 1;

        $form_valid = $this->validateEmployeeForm();
        if ($form_valid !== true) {
            $message = 'Invalid Registration Form';
            \Core\WindowMessage::showMessage($message, 'bad');
            return false;
        }
        if ($form_valid === true) {
            $message = 'Valid Registration Form - Trying now...';
            \Core\WindowMessage::showMessage($message, 'good');
            #return true;
        }
        $afterwards = $this->applyRegisterResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        return $result;
    }

    public function applyRegisterResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            if ($request_data['status'] === 'OK') {
                \ISOPHP\js_core::$console->log('saying hello');
                $welcome_message = "You have successfully registered";
                \Core\WindowMessage::showMessage($welcome_message, 'good');
                $navigate = new \Model\Navigate();
                $extra_params = $pageVars['params'];
                // $extra_params['user_logged'] = $request_data->user;
                $extra_params['user_logged']['user'] = $request_data['user'] ;
                $extra_params['user_logged']['user_uploads'] = $request_data['user_uploads'];
                $extra_params['user_logged']['user_details'] = $request_data['user_details'];

                $registry = \ISOPHP\core::$registry;
                \ISOPHP\js_core::$console->log('registry is ', $registry);
                \ISOPHP\js_core::$console->log('logged user to registry is ', $extra_params['user_logged']);
                $registry::setValue('user_logged', $extra_params['user_logged']);

                \ISOPHP\js_core::$console->log('apply login', $extra_params);
                \ISOPHP\js_core::$console->log('CHANGING SOMETHING', $extra_params);

                $navigate->route('Home', 'show', $extra_params, '/home');

            } else if ($request_data->status !== 'OK') {
                $welcome_message = $request_data->error;
                \ISOPHP\js_core::$console->log('saying ' . $welcome_message);
                \Core\WindowMessage::showMessage($welcome_message, 'bad');
            }
        };

        return $func;
    }

    public function validateHiringForm()
    {

        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars = array();
        $vars['user'] = $jQuery('#username')->val();
        $vars['first_name'] = $jQuery('#first_name')->val();
        $vars['last_name'] = $jQuery('#last_name')->val();
        $vars['email'] = $jQuery('#email')->val();
        $vars['company_name'] = $jQuery('#company_name')->val();
        $vars['pass'] = $jQuery('#pass')->val();
        $vars['pass_conf'] = $jQuery('#pass_conf')->val();
        $user_length = \ISOPHP\core::$php->strlen($vars['user']);
        if ($user_length < 3) {
            $error_message = 'User name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        if ($user_length < 3) {
            $error_message = 'User name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $first_name = \ISOPHP\core::$php->strlen($vars['first_name']);
        if ($first_name < 3) {
            $error_message = 'First name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $last_name = \ISOPHP\core::$php->strlen($vars['last_name']);
        if ($last_name < 3) {
            $error_message = 'Last name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        if ($vars['email'] == '') {
            $error_message = 'Email address can not be empty';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }


        $company_name_length = \ISOPHP\core::$php->strlen($vars['company_name']);
        if ($company_name_length < 3) {
            $error_message = 'Company name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $pass_length = \ISOPHP\core::$php->strlen($vars['pass']);
        if ($pass_length < 6) {
            $error_message = 'Password field must be at least 6 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }
        if ($vars['pass'] !== $vars['pass_conf']) {
            $error_message = 'Password Confirmation field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }
        return true;
    }

    public function validateEmployeeForm()
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars = array();
        $vars['user'] = $jQuery('#username')->val();
        $vars['full_name'] = $jQuery('#full_name')->val();
        $vars['email'] = $jQuery('#email')->val();
        $vars['pass'] = $jQuery('#pass')->val();
        $vars['pass_conf'] = $jQuery('#pass_conf')->val();
        $user_length = \ISOPHP\core::$php->strlen($vars['user']);
        if ($user_length < 3) {
            $error_message = 'User name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        if ($user_length < 3) {
            $error_message = 'User name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $pull_name = \ISOPHP\core::$php->strlen($vars['full_name']);
        if ($pull_name < 3) {
            $error_message = 'Full name field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        if ($vars['email'] == '') {
            $error_message = 'Email address can not be empty';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $pass_length = \ISOPHP\core::$php->strlen($vars['pass']);
        if ($pass_length < 6) {
            $error_message = 'Password field must be at least 6 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }
        if ($vars['pass'] !== $vars['pass_conf']) {
            $error_message = 'Password Confirmation field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }
        return true;
    }


    public static function bindButtons()
    {
        return function () {
            if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
                \ISOPHP\js_core::$console->log('Binding buttons');
                $jQuery = \ISOPHP\js_core::$jQuery;

                $perform_registration = $jQuery('#perform-registration');
                $perform_registration->on('click', function () {
                    $navigate = new \Model\Navigate();
                    $navigate->route('Register', 'attempt', array());
                });

                $perform_registration = $jQuery('#perform-hiring-interest-reg-attempt');
                $perform_registration->on('click', function () {
                    $navigate = new \Model\Navigate();
                    $navigate->route('Register', 'hiring-interest-reg-attempt', array(), 'register/hiring');
                });

                $cancel_login = $jQuery('#cancel-registration');
                $cancel_login->on('click', function () {
                    $navigate = new \Model\Navigate();
                    $navigate->route('LandingPage', 'show', array(), '/home');
                });
            }
        };
    }

    public static function bindMockIProov($pageVars)
    {
        return function ($jq_this) use ($pageVars) {
            \ISOPHP\js_core::$console->log('Binding mock iproov');
            $jQuery = \ISOPHP\js_core::$jQuery;
            $iproov_mock = $jQuery('#iproov_mock_wrap');
            $mock_image = '<img src="' . IMAGE_ASSET_PREFIX . 'app/Register/Assets/images/canny-bound-shift-moving.gif" alt="Mocking IProov" class="iproov_mock_image" />';
            $iproov_mock->html($mock_image);
            $go_zero_credit = function () use ($pageVars, $jq_this) {
                \Core\WindowMessage::showMessage('Go Zero Credit Start', 'good');
                $jq_this->getMockIProovResult($pageVars);
                \Core\WindowMessage::showMessage('Go Zero Credit Start', 'good');
            };
            $go_zero_credit();
        };
    }

    public function getMockIProovResult($pageVars)
    {
        $vars['control'] = 'Register';
        $vars['action'] = 'zero-attempt';
        $after = $this->applyMockIProovResult($pageVars);
        $first = function () use ($vars, $after) {
            // FFS DONT CALL THIS STATICALLY IT'LL CACHE THE OUTPUT
            $base = new \Model\Base();
            \ISOPHP\js_core::$console->log('about to perform reg request: ');
            return $base->performRequest($vars, $after);
        };
        $result = \ISOPHP\js_core::$window->setTimeout($first, 5000);
        \ISOPHP\js_core::$console->log('Register MockIProov Data Model: ', $result);
        return $result;
    }

    public function applyMockIProovResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our registration MockIProov result to', $request_data);
            if ($request_data->status === 'OK') {
                \ISOPHP\js_core::$console->log('saying hello');
                $welcome_message = "Hello there, " . $request_data->user_result->user_zero_id;
                \Core\WindowMessage::showMessage($welcome_message, 'good');
                $navigate = new \Model\Navigate();
                $registry = \ISOPHP\core::$registry;
                \ISOPHP\js_core::$console->log('registry is ', $registry);
                $registry::setValue('user_logged', $request_data->user_result);
                $extra_params = $pageVars['params'];
                $extra_params['user_logged'] = $request_data->user_result;
                \ISOPHP\js_core::$console->log('apply registration', $extra_params);
                $navigate->route('HomeSummary', 'show', $extra_params, 'home');
            } else if ($request_data->status !== 'OK') {
                $welcome_message = 'Registration MockIProov Failed';
                \ISOPHP\js_core::$console->log('saying ' . $welcome_message);
                \Core\WindowMessage::showMessage($welcome_message, 'bad');
            }
        };
        return $func;
    }

}


// WEBPACK FOOTER //
// app/Register/Model/RegisterPageModel.php